import React, { useState, useEffect, useRef } from 'react';
import Hosts from '../../Hosts'
import {reqPOST, reqGET, passwordHash, repo_banner_link, set_language} from '../../Utils'

import Modal from "react-modal";

import { language } from '../WEBContent/Language';

import { confirmAlert } from 'react-confirm-alert';
//import { getTokenInfo } from '../../UseToken';

import Swal from 'sweetalert2'

Modal.setAppElement("#root");

const LoginForm = (props) => {
  /*  async function loginUser(credentials) {
     return fetch(Hosts.SIMCore_API + '/' + props.loginType, {
       //return fetch(Hosts.SIMCore_API+'/auth/'+props.loginType, {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(credentials)
     })
       .then(data => data.json())
     //.then(res =>res.token) */

  const data_interface = {
    id: '',
    info: {
        companycode: Hosts.companycode,
        username: '',
        password: '',
        name: '',
        surname: '',
        location: '',
        email: '',
        from: '',
        vat: '999999990',
        marketing:false,
        terms_checked: true,
        rgpd: true,
        ativo: true,
        birthday: '',
        entity_type: '',
        observation: '',
        identification: {
          tipo_identificacao: '',
          numero_identificacao: '',
          validade_identificacao: ''
        },
        notifications: [],
        use_preferences: { language: 'PT' }
    },
    addresses: [{
        //village: '',
        //city: '',
        //type: [],
        //region: '',
        country: '',
        //apartado: '',
        //localidade: '',
        //contats: [],
        //principal: '',
        //observation: '',
        //postal_code: '',
        //street_name: '',
        //address_detail: '',
    }],
    contacts: [{
        contactemail: '',
        email: '',

        principal: 'true',
        //extensions: [],
        observation: '',

        //building_number: '',
        /*person_responsables: [{
            id: '',
            name: '',
            email: '',
            extensions: '',
            observation: '',
            mobile_phone: ''
        }],*/
    }],
    profile: { name: "Cliente" },
    notifications: []
  }

  const [ , set_dados ] = useState( null ) ;
  const dados = useRef( data_interface ) ;

  const [lang, set_lang] = useState('pt');

  const [/*companycode,*/ setCompanyCode] = useState('');
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [password_recovery, setPasswordRecovery] = useState('');

  const [input_type, setInputType] = useState('password');

  const [refresh, setRefresh] = useState(0);

  const [agree, setAgree] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [link_final, /*set_link_final*/] = useState(Hosts.EMAIL_WEB_SITE_URL);

  /*const check_entity_field = async (name, value) => {
		reqGET(`${Hosts.SIMCore_API}/entities/list/${Hosts.companycode}/*`)
			.then(res => {

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k[name] === value) {
						ja_existe = true
					}
				})

				if (ja_existe === false) {

					return

				} else {
					set_dados(dados.current.info[name] = '');
					setRefresh(refresh + 1)
          //console.log('aki aki');
          Swal.fire({
              title: (name === 'email' ? language[lang].contact_email : language[lang].username_email),
              text: language[lang].username_error_message,
              icon: 'error',
              //showCancelButton: true,
              confirmButtonColor: '#08396a',
              //confirmButtonText: 'Tentar novamente',
            })

          //alert('Já existe um registo com este username.');
					// confirmAlert({
					// 	title: 'Aviso',
					// 	message: 'Já existe um registo com este nickname.',
					// 	buttons: [
					// 		{
					// 			label: 'Voltar',
					// 			onClick: () => { 
					// 				//set_dados(dados.current.info.username = '');
					// 				//setRefresh(refresh + 1)
					// 				return
					// 			}
					// 		},

					// 	]
					// })

					//console.log(ja_existe);
				}
			}
			)
	}*/

  const check_entity_field_api = async (name, value) => {
		reqGET(`${Hosts.SIMCore_API}/app/entities/username/${Hosts.companycode}/${value}`)
			.then(res => {

        //console.log(res);

        if (res.data[0].response === false) {

					return

				} else {
					dados.current.info['email'] = ''
					dados.current.info['username'] = ''

          //console.log('aki aki');
          Swal.fire({
              title: (name === 'email' ? language[lang].contact_email : language[lang].username_email),
              text: language[lang].username_error_message,
              icon: 'error',
              //showCancelButton: true,
              confirmButtonColor: '#08396a',
              //confirmButtonText: 'Tentar novamente',
            })

            set_dados(dados.current, )

            setRefresh(refresh + 1)

				}
			}
			)
	}

  const handle_change_info = async (e) => {
    const { name, value } = e.target;
  
    if ((name === 'username' || name === 'email') && value !== '') {
      dados.current.info['username'] = value
      dados.current.info['email'] = value
			
			//check_entity_field(name, value)
      //check_entity_field_api(name, value)
      await checkEmailValidation(value, name)

      set_dados(dados.current, )
			
		}
    else {
      set_dados(dados.current.info[name] = value)
    }

    await checkFieldValidation()

    /*if ((name === 'username') && value !== '') {
      
      check_username(dados.current.info['username'])
      checkEmailValidation(dados.current.info['username'], name)
      
    }

    if ((name === 'email') && value !== '') {
      checkEmailValidation(dados.current.info['email'], name)
      
    }*/

    setRefresh(refresh + 1)

    //console.log('agree handle change info: ', agree)



    // console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
    // console.log('Dados Current:' + JSON.stringify(dados))
  }

  const handle_change_info_2 = async (e) => {
		const { name, value } = e.target;

    // console.log('handle_change_info_2')

		set_dados(dados.current.info[name] = value)

    console.log('111 name', name)
    if(name !== 'username' && name !== 'email' && dados.current.info.username !== '') {
      await checkEmailValidation()
    }

    /*if ((name === 'username') && value !== '') {
      
      check_username(dados.current.info['username'])
      
    }*/
		 
		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current 2:' + JSON.stringify(dados))
	}

  const handle_change_contacts = async  (e) => {
    const { name, value } = e.target;

    set_dados(dados.current.info[name] = value)
    
    await checkFieldValidation()

    setRefresh(refresh + 1)


    // console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
    // console.log('Dados Current:' + JSON.stringify(dados))
  }

  const handle_change_password = (e) => {
		const { value } = e.target;

    console.log('handle_change_password')

		if (dados.current.info.password !== '' && value === dados.current.info.password) {
      
			console.log('A password introduzida e a confirmação são iguais')
      
		}
		else {
      confirmAlert({
        title: language[lang].password,
        message: language[lang].confirmation_password_error_message,
        buttons: [
          {
            label: language[lang].back,
            onClick: () => { return }
          }

        ]
      });
			//alert(language[lang].confirmation_password_error_message)
		}

    checkFieldValidation()
	}

  const checkboxHandler = () => {
    // if agree === true, it will be set to false
    // if agree === false, it will be set to true

    console.log('checkboxHandler')

    setAgree(!agree);
    dados.current.info['terms_checked'] = !agree
    setRefresh(refresh + 1)

    checkFieldValidation()

    //console.log(!agree)
    //setRefresh(refresh + 1)
    // Don't miss the exclamation mark

    //console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
    //console.log('Dados Current:' + JSON.stringify(dados))
  }

  const checkboxHandler_reload = (agree) => {
    
    //console.log('AGREE', agree)
    if (agree === true){
        return true
    }else {
        return false
    }
    // if agree === false, it will be set to true
    //setAgree(!agree);
    // Don't miss the exclamation mark
  }



  const checkboxHandler_2 = () => {
    // if agree === true, it will be set to false
    // if agree === false, it will be set to true

    console.log('checkboxHandler_2')

    setAgree2(!agree2);
    //dados.current.info['rgpd'] = !agree2
    dados.current.info['marketing'] = !agree2
    setRefresh(refresh + 1)

    checkFieldValidation()

    //console.log(!agree)
    //setRefresh(refresh + 1)
    // Don't miss the exclamation mark

    //console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
    //console.log('Dados Current:' + JSON.stringify(dados))
  }

  const checkboxHandler_2_reload = (agree2) => {
    //console.log('AGREE', agree)

    if (agree2 === true){
        return true
    }else {
        return false
    }
    // if agree === false, it will be set to true
    //setAgree(!agree);
    // Don't miss the exclamation mark
  }

  const checkFieldValidation = async () => {


    console.log('checkFieldValidation')

    //console.log('checkFieldValidation agree', agree)

		let input01 = (dados.current.info.name !== '')
		// let input02 = (dados.current.info.surname !== '')
    // let input03 = (dados.current.info.location !== '')
    let input04 = (dados.current.info.email !== '')
    let input05 = (dados.current.info.password !== '')
    let input06 = (dados.current.info.username !== '')
    let input07 = (dados.current.info.terms_checked === true)
    //let input08 = (dados.current.info.rgpd_checked === true)

    if(!input04 && input06) {
      set_dados(dados.current.info.email = dados.current.info.username)
      input04 = input06

      await checkEmailValidation(dados.current.info.username, dados.current.info.name)
    }
    else if(input04 && !input06) {
      set_dados(dados.current.info.username = dados.current.info.email)
      input06 = input04

      await checkEmailValidation(dados.current.info.username, dados.current.info.name)
    }

		if(input01 && input04 && input05 && input06 & input07) {
			setBtnDisabled(false);
		} else{
			setBtnDisabled(true);
		}

	}

  const checkEmailValidation = async (data, name) => {

    const pattern_email_validation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/;

    if(pattern_email_validation.test(data) === false){
        dados.current.info['username'] = ''
        dados.current.info['email'] = ''
        set_dados(dados.current,);
        setRefresh(refresh + 1)

        await Swal.fire({
          title: language[lang].email,
          text: language[lang].email_error_message,
          icon: 'error',
          //showCancelButton: true,
          confirmButtonColor: '#08396a',
          //confirmButtonText: 'Tentar novamente',
        })

        /*confirmAlert({
          title: language[lang].email,
          message: language[lang].email_error_message,
          buttons: [
            {
              label: language[lang].back,
              onClick: () => { return }
            }

          ]
        });*/
    }
    else {
      await check_entity_field_api(name, data)
    }
  }

  const change_lang = (l) => {
      set_language(l)
      set_lang(l)
      //window.location.reload()

      //console.log('language login form', localStorage.getItem('lang'))
      //console.log('localstorage login form', localStorage)
  }

  useEffect(() => {

      if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
          change_lang('pt')
      }
      else {
          set_lang(localStorage.getItem('lang'))
          //console.log('aki login form', localStorage)
      }


  }, [])

  const handleSubmit = e => {
    //e.preventDefault();
    /*  const objToken = await loginUser({
       companycode,
       username,
       password: Utils.passwordHash(password)
     }); */

    //PASSWORD -> MD5
    //console.log('Token:' + crypto.createHash('md5').update('hftpaak17').digest("hex"));

    //console.log('Token:' + objToken);
    //console.log(JSON.stringify(objToken))

    e.preventDefault();

    if(localStorage.snowCart !== undefined && localStorage.snowCart !== null) {
      let aux = localStorage.snowCart
      localStorage.clear();
      localStorage.snowCart = aux
    }
    else {
      localStorage.clear();
    }
    
    change_lang(lang)

    reqPOST(Hosts.SIMCore_API + '/' + props.loginType, {
      companycode: Hosts.companycode,
      //companycode,
      username,
      password: passwordHash(password)
    }).then(objToken => {
      if (objToken.token !== false) {


        

        //console.log('SETOU->', objToken)
        props.setToken(objToken);
       // console.log(JSON.stringify(objToken))
        //alert('Autenticado!')
        
        /*  confirmAlert({
           title: 'SIM.Credit.Net',
           message: 'Sistema de Gestão de Créditos',
           buttons: [
             {
               label: 'Entrar',
               onClick: () => { */
        //console.log(objToken.user_info[0].profile.name)

        //console.log('COMAPNY-CODE: ' + objToken.user_info[0].info.companycode)
        //localStorage.setItem('companycode', companycode);
        //localStorage.setItem('companycode', companycode);
        /*  localStorage.setItem('username', objToken.user_info[0].info.name);
         localStorage.setItem('companycode', objToken.user_info[0].info.companycode);
 
         localStorage.setItem('profile', objToken.user_info[0].profile.name);
         localStorage.setItem('user_info', objToken.user_info[0]); */

        // if (getTokenInfo().companycode === companycode) {

        //}
        //props.history.push('/')
        /*  }
       }
  
     ]
   });
  */
      }
      else {
        confirmAlert({
          title: language[lang].failed_login,
          message: language[lang].incorrect_login_data,
          buttons: [
            {
              label: language[lang].back,
              onClick: () => { return }
            }

          ]
        });
        //alert('Não Autenticado');
        localStorage.clear();
        //setToken(token);
      }
    })
  }

	const [isOpen, setIsOpen] = useState(false);
	const [isOpen2, setIsOpen2] = useState(false);

  function toggleModal() {
		setIsOpen(!isOpen);
	}

  function toggleModal2() {
		setIsOpen2(!isOpen2);
	}

  const togglePwd = async e => {
    if (input_type.localeCompare('text') === 0)
      setInputType('password');
    else
      setInputType('text');
  }

  const sendRecovery = async () => {
    await reqGET(Hosts.SIMCore_API + '/entities/password/recovery/' + Hosts.companycode + '/' + password_recovery)
      .then(res => {
        //console.log(res)

        if(res.status === 200) {
          let link_aux = link_final + '/regist/client/recovery/' + res.data

          let mailOptions = {
            from: Hosts.contactFrom,
            // vários emails separados por virgulas
            //to: web.dev@assec.pt',
            to: password_recovery,
            //cc-> opcional
            //cc: Hosts.contactFrom,
            subject: Hosts.webSiteTitle + ' - ' + language[lang].contact_recovery,
            //text: 'Teste de EMAIL ', -> opcional
            html:
      
                '<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
                    '<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
                        '<tr style="border-collapse: collapse;">' +
                            '<td style="border-collapse: collapse;">' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
                                            '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
                                                '<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
                                            '</a>'+
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                                '<table width="540" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 540px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" class style="padding:0 0 10px; border-collapse:collapse;">' +
                                            '<div style="width:540px; margin: 0 auto; padding-left: 30px; padding-right: 30px;">'+
                                                '<h4 style="text-transform: uppercase;">'+ language[lang].contact_recovery +':</h4>'+
                                                '<span><label>' + language[lang].password_recover + '</label></span>'+
                                                '<br/>'+
                                                '<br/>'+
                                                '<span><label>' + language[lang].password_recover_2 + ' <a href="'+ link_aux +'" alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '">' + language[lang].recover_password + '</a></label></span>'+
                                                '<br/>'+
                                                '<br/>'+
                                                '<span><label>' + language[lang].password_recover_3 + '</label></span>'+
                                            '</div>'+
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
                                            '<div style="margin: 0 auto; width:600px;">'+
                                                '<div style="text-align: center; font-size: small; color:'+ Hosts.FOOTER_EMAIL_TEXT_COLOR +'">'+
                                                    '<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>'+
                                                    '<br/>'+
                                                    '<span>' + Hosts.webSiteAdress + '</span>'+
                                                    '<br/>'+
                                                    '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="text-decoration:none;"> '+
                                                        '<span style="color: #FFFFFF;" >'+ Hosts.EMAIL_WEB_SITE_URL +'</span>' +
                                                    '</a>'+
                                                '</div>'+
                                            '</div>' +
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                            '</td>' +
                        '</tr>' +
                    '</table>' +
                '</div>',
          }; 

          reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
            .then(() => { 

              toggleModal()

              confirmAlert({
                title: language[lang].submitted_application,
                message: language[lang].email_recover_pass,
                buttons: [
                  {
                    label: language[lang].back,
                    onClick: () => { return }
                  }
      
                ]
              });

            })
            .catch((error) => console.log(error)/*alert('Problema ao enviar notificações!')*/)
        }
        else {
          confirmAlert({
            title: language[lang].incorrect_request,
            message: language[lang].email_recover_pass_2,
            buttons: [
              {
                label: language[lang].back,
                onClick: () => { return }
              }
  
            ]
          });
        }

        // TODO 
        // Enviar email com link + hash

        /*
        reqPOST(Hosts.SIMCore_API + '/entities/password_recovery/', {recovery_hash: res.data, new_password: passwordHash('cunha#2025')})
          .then(res => {
            console.log(res)
    
            // TODO 
            // Enviar email com link + hash
    
          })
          .catch(() => 404)
          */

      })
      .catch(() => 404)
  }

  const saveUser = async () => {
    confirmAlert({
      title: language[lang].insert_title,
      message: language[lang].insert_text,
      buttons: [
        {
          label: language[lang].yes,
          onClick: () => {

              let password = dados.current.info.password;
              dados.current.info.password = passwordHash(password);
              dados.current.info['from'] = 'web';

              reqPOST(`${Hosts.SIMCore_API}/app/entities`, dados.current)
                  .then(() => {   
                      
                      //alert('Registo efetuado com sucesso!\n\nConsulte os seus dados de acesso no email enviado.')
                      set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                      document.getElementById('terms').checked = false 
                      toggleModal2()
                      //props.history.push(endpoints.list) 

                      /*Swal.fire({
                        title: language[lang].insert_title,
                        text: language[lang].insert_success,
                        icon: 'success',
                        //showCancelButton: true,
                        confirmButtonColor: '#08396a',
                        //confirmButtonText: 'Tentar novamente',
                      })*/

                      confirmAlert({
                        title: language[lang].user_regist,
                        message: language[lang].regist_form_sucess_message,
                        buttons: [
                          {
                            label: language[lang].back,
                            onClick: () => { return }
                          }
              
                        ]
                      });

                      

                  })
                  .catch((error) => console.log(error) /*alert('Problema ao atualizar Registo!')*/)
          }

        },
        {
          label: language[lang].no,
          onClick: () => { return }
        }
			]
		})
    
  }

  return (
    <>
    <form onSubmit={handleSubmit}>
      <div className="form-group d-none">
        <h3 className="assec-my-25">{language[lang].welcome}</h3>
        <label>
          <p className="mb-1">{language[lang].magazine_code}</p>
          <input type="text" className="form-input" name='companycode' value={Hosts.companycode} onChange={(e) => setCompanyCode(e.target.value)} />
        </label>
      </div>
      <div className="form-group">
        <label>
          <p className="mb-1">{language[lang].username}</p>
          <input type="text" className="form-input" name='username' value={username} onChange={(e) => setUserName(e.target.value)} />
        </label>
      </div>
      <div className="form-group position-relative">
        <label>
          <p className="mb-1">{language[lang].password}</p>
          <input type={input_type} className="form-input input-pwd" value={password} onChange={(e) => setPassword(e.target.value)} />
          <img alt='' onClick={togglePwd} src={ input_type === 'password' ? './img/view.svg' : './img/view_password.svg'} />
        </label>
      </div>
      
      <div className="form-group">
        <button className="form-button btn-primary" type="submit">{language[lang].login}</button>
      </div>

      <div className='form-group mb-0'>
        <button className="small small-form" type="button" onClick={toggleModal2} >{language[lang].register_here}!</button>
      </div>
      <div className="form-group">
        <button className="small small-form" variant="primary" type="button" onClick={toggleModal} >{language[lang].recover_password}!</button>
      </div>
    </form>

    <Modal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      contentLabel={language[lang].recover_password}
      className="mymodalRecovery div-right"
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
      <div className="assec-text-right">
        <button alt={language[lang].close} title={language[lang].close} onClick={toggleModal}>X</button>
      </div>
      <div className="div-modal">
        <div className="modal-body modal-modal">
            <h4 className='dash-title'>{language[lang].recover_password}</h4>
            <div className="form-group assec-mt-30">
              <label>
                <input type="email" className="form-input" id='email-modal-recuperacao' placeholder={language[lang].email_placeholder} name='email' onChange={(e) => setPasswordRecovery(e.target.value)} />
              </label>
            </div>
            <div className="form-group assec-mt-30">
              <button type="button" className="form-button btn-primary" onClick={() => sendRecovery()}>{language[lang].send}</button>
            </div>
          </div>
      </div>
    </Modal>
    <Modal
      isOpen={isOpen2}
      onRequestClose={toggleModal2}
      contentLabel={language[lang].register_here}
      className="mymodal div-right"
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
      <div className="assec-text-right">
        <button alt={language[lang].close} title={language[lang].close} onClick={toggleModal2}><i className="bi bi-x-lg"></i></button>
      </div>
      <div className="div-modal">
        <div className="modal-body modal-modal">
            <h4 className='dash-title'>{language[lang].register_here}!</h4>
            <div className="form-group assec-mt-30">
              <div className="row">

                {/*<div className='form-group col-12 col-md-6 d-none'>
                  <label>{language[lang].contact_email}*</label>
                  <input type="email" className="form-input" placeholder={language[lang].contact_email_placeholder} name='email' value={dados.current.info.email} onBlur={handle_change_info} onChange={handle_change_info_2} required />
                </div>*/}

                <div className='form-group col-12 col-md-6'>
                  <label>{language[lang].name}*</label>
                  <input type="text" className="form-input" placeholder={language[lang].name_placeholder} name='name' value={dados.current.info.name} onChange={handle_change_info} required />
                </div>

                <div className='form-group col-12 col-md-6'>
                  <label>{language[lang].mobile_phone}</label>
                  <input type="text" className="form-input" placeholder={language[lang].mobile_phone_placeholder} name='mobile_phone' value={dados.current.contacts !== undefined && dados.current.contacts.length > 0 ? dados.current.contacts[0].mobile_phone : ''} onChange={handle_change_contacts} />
                </div>

                <div className='form-group col-12 col-md-6 d-none'>
                  <label>{language[lang].surname}*</label>
                  <input type="text" className="form-input" placeholder={language[lang].surname_insert} name='surname' value={dados.current.info.surname} onChange={handle_change_info} required />
                </div>

                <div className='form-group col-12 col-md-6 d-none'>
                  <label>{language[lang].location}</label>
                  <input type="text" name="location" className="form-input" placeholder={language[lang].location_placeholder} value={dados.current.info.location} onChange={handle_change_info} />
                </div>

                <h4>{language[lang].access_data}</h4>

                {/* <div className='form-group col-12 col-md-6'>
                  <label>{language[lang].user}</label>
                  <input type="text" name="username" className="form-input" placeholder={language[lang].username_insert}/>
                </div> */}
    
                <div className='form-group col-12 col-md-6 me-5'>
                  <label>{language[lang].username_email}*</label>
                  <input type="email" className="form-input" placeholder={language[lang].username_insert} name='username' value={dados.current.info.username} onBlur={handle_change_info} onChange={handle_change_info_2} required/>
                </div>
            
                <div className='form-group col-12 col-md-6'>
                  <label>{language[lang].new_password}*</label>
                  <input type="password" name="password" value={dados.current.info.password} className="form-input" placeholder={language[lang].new_password_placeholder} onChange={handle_change_info} />
                </div>

                <div className='form-group col-12 col-md-6'>
                  <label>{language[lang].new_password_2}*</label>
                  <input type="password" name="password_conf" /*value={password_nova_conf}*/ className="form-input" placeholder={language[lang].new_password_2_placeholder} onBlur={handle_change_password} /*onChange={handle_change_password_conf}*//>
                </div>

                <div className="col-12 mt-3">
                    <input 
                      type="checkbox"
                      name="rgpd_check"
                      id="rgpd"
                      onChange={checkboxHandler_2}
                      defaultChecked={checkboxHandler_2_reload(agree2)}
                      className="me-2"
                    />
                    <label htmlFor="rgpd">{language[lang].agree_rgpd}</label>
                    
                </div>

                <div className="col-12 mt-3">
                    <input 
                      type="checkbox"
                      name="terms_check"
                      id="terms"
                      onChange={checkboxHandler}
                      defaultChecked={checkboxHandler_reload(agree)}
                      className="me-2"
                      required
                    />
                    <label htmlFor="terms">{language[lang].agree_terms_conditions}
                        <a /*href={Hosts.WEB_SITE_URI + "terms-conditions"}*/ href="https://skiserradaestrela.com/terms-conditions" target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>
                    </label>
                    <label className="ps-2 small" htmlFor="agree">{language[lang].terms_conditions_required}</label>
                    
                </div>
              </div>
            </div>
            <div className="form-group assec-mt-30">
              <button type="button" onClick={() => saveUser()} className="form-button btn-primary w-auto" disabled={btnDisabled} /*disabled={!agree}*/ >{language[lang].send}</button>
            </div>
          </div>
      </div>
    </Modal>
    </>
  );


}

/*
LoginForm.propTypes = {
    setToken: PropTypes.func.isRequired
  };
*/

export default LoginForm;
